import React, { useState, useRef, useEffect } from 'react';

/**
 * HOC that defers rendering children until they are near the viewport.
 * Migrated from src/components/HighOrderComponent.js to newSrc/shared/components.
 */
const LazyRender = ({ children, placeholder = null, rootMargin = '200px' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return <div ref={ref}>{isVisible ? children : placeholder}</div>;
};

export default LazyRender;
